module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Title","text":"Text","download":"download","file":"File","add attachment":"add attachment","delete attachment":"delete attachment","cancel":"Cancel","send":"Send"},"de":{"title":"Titel","text":"Text","download":"herunterladen","file":"Datei","add attachment":"Anhang hinzufügen","delete attachment":"Anhang löschen","cancel":"Abbrechen","send":"Senden"}}')
  delete Component.options._Ctor
}
